import React from "react";
// styles
import "./footer_styles.css";
// images
import mugshot from "./../../images/chris_75.png";
import SocialMediaLinks from "../socialMediaStuff/SocialMediaLinks";

const Footer = function(props) {
  return (
    <div className={"blogPost--footer"}>
      <img src={mugshot} alt="Chris Dennett's mugshot" />
      <div>
        <p>
          Experiments by{" "}
          <a
            href="https://www.chrisdennett.co.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            Chris Dennett
          </a>
        </p>
        <SocialMediaLinks />
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js